import { CHAT_TYPE } from './constants';

// --- Subjects ---
export const SUBJECTS = [
    { value: 1, label: 'Moral Education / Citizenship / Values Education' },
    { value: 2, label: 'Technology / ICT / Computer Science' },
    { value: 3, label: 'Mathematics' },
    { value: 4, label: 'English Language / Literature' },
    { value: 5, label: 'Science: General Science / Biology / Chemistry / Physics' },
    { value: 6, label: 'Social Studies: History / Civics / Geography / Economics' },
    { value: 7, label: 'Art and Design' },
    { value: 8, label: 'Music' },
    { value: 9, label: 'Physical Education / Health' },
    { value: 10, label: 'Other (Please specify)' },
];


// --- Teaching Methods (Best Delivery) ---
export const TEACHING_METHODS = [
    { value: 0, label: "Lecture", description: "Students read through focused delivery of key concepts" },
    { value: 1, label: "Storytelling", description: "Students are given narratives to illustrate issues" },
    { value: 2, label: "Case Study", description: "Students go through scenario-based situations" },
    { value: 3, label: "Group Discussion", description: "Students interact in an real-time discussion with their peers" },
    { value: 4, label: "Role-Play", description: "Students simulate scenarios based on assigned roles" },
    { value: 5, label: "Journaling", description: "Students respond in a private written exercise" },
    { value: 6, label: "Polls", description: "Students answer questions and see their peer’s responses" },
    { value: 7, label: "Design Challenges", description: "Students create design projects to submit" },
    // { value: 8, label: "Others" },
];

// --- Session Formats ---
export const DELIVERY_FORMATS = [
    // 🔴 Independent E-Learning
    {
        label: "Independent E-Learning Module",
        code: "Format 1",
        group: "Independent E-Learning",
        techEnvironment: "Fully digital, self-paced via LMS or tools",
        learningGoal: "Empower learners to explore content independently and flexibly through an interactive learning system.",
        color: "red"
    },
    // 🔵 Guided Lecture / Teacher-Led Presentation
    {
        label: "Projected Lecture with Limited Student Devices",
        code: "Format 2.A",
        group: "Guided Lecture / Teacher-Led Presentation",
        techEnvironment: "Teacher-only device",
        learningGoal: "Deliver core knowledge efficiently with light interaction and basic reflection.",
        color: "blue"
    },
    {
        label: "Interactive Lecture with Student Devices",
        code: "Format 2.B",
        group: "Guided Lecture / Teacher-Led Presentation",
        techEnvironment: "Students use own devices",
        learningGoal: "Deliver core knowledge with enhanced interaction and real-time digital participation.",
        color: "blue"
    },
    // 🟡 Group-Based Collaborative Learning
    {
        label: "Analog Group Collaboration with Projected Prompts",
        code: "Format 3.A",
        group: "Group-Based Collaborative Learning",
        techEnvironment: "Teacher-only device",
        learningGoal: "Foster deep engagement through face-to-face collaboration and social learning.",
        color: "yellow"
    },
    {
        label: "Blended Group Collaboration with Student Devices",
        code: "Format 3.B",
        group: "Group-Based Collaborative Learning",
        techEnvironment: "Students use own devices",
        learningGoal: "Blend input, peer discussion, and digital collaboration to deepen conceptual understanding.",
        color: "yellow"
    },
    // 🟢 Individual Reflection and Task-Based Learning
    {
        label: "Offline Individual Reflection with Teacher Guidance",
        code: "Format 4.A",
        group: "Individual Reflection and Task-Based Learning",
        techEnvironment: "Teacher projects prompts",
        learningGoal: "Encourage independent thinking and self-expression with minimal tech dependency.",
        color: "green"
    },
    {
        label: "Digital Individual Task with Student Submission",
        code: "Format 4.B",
        group: "Individual Reflection and Task-Based Learning",
        techEnvironment: "Students use own devices",
        learningGoal: "Support deeper, personalized reflection and accountability using digital tools.",
        color: "green"
    },
    // Other
    // {
    //     label: "Other",
    //     code: "Other",
    //     group: "Other",
    //     techEnvironment: "",
    //     learningGoal: "",
    //     color: "grey"
    // }
];

// --- Tech Environments ---
export const TECH_ENVIRONMENTS = [
    { value: 1, label: "Only the teacher/instructor has a device, projecting slides or materials; learners do not have personal device access." },
    { value: 2, label: "Both learners and instructors have device access during class." },
    { value: 3, label: "Learners will have occasional access to devices (e.g., lab days), but most sessions rely on teacher-led projection." },
    { value: 4, label: "Neither teachers nor learners will use digital devices during class." },
];

// --- Sensitivities (Cultural, etc) ---
export const SENSITIVITIES = [
    { 
        value: 1, 
        label: "Faith-based or cultural values and perspectives",
        sublabel: "(e.g., Islamic, Christian, Jewish, Hindu, Buddhist, Indigenous, or other traditions)"
    },
    { value: 2, label: "Gender, identity, and inclusivity" },
    { value: 3, label: "Local laws, regulations, or policies" },
    { value: 4, label: "Parental or community sensitivities regarding controversial topics" },
    { value: 5, label: "None — no special considerations" },
    { value: 6, label: "Other" },
];

// --- Focus areas (for step with 1-3 rating) ---
export const FOCUS_FIELDS = [
    { key: "FocusProblem", label: "Understanding problems" },
    { key: "FocusSolution", label: "Exploring solutions" },
    { key: "FocusMindset", label: "Positive mindset" },
    { key: "FocusKS_F", label: "Factual knowledge & skills" },
    { key: "FocusKS_C", label: "Conceptual knowledge & skills" },
    { key: "FocusKS_P", label: "Procedural knowledge & skills" },
    { key: "FocusKS_M", label: "Metacognitive knowledge & skills" },
    { key: "FocusAB_A", label: "Attitudes" },
    { key: "FocusAB_P", label: "Perceived norms & prototypes" },
    { key: "FocusAB_I", label: "Intention & willingness" },
    { key: "FocusAB_B", label: "Behaviours & habits" },
];

// --- Content Styles ---
export const CONTENT_STYLES = [
    { value: "Claymation", label: "Claymation", image: require('../assets/images/PBDQ_Style_Claymation.png') },
    { value: "3D_Cartoon", label: "3D Cartoon", image: require('../assets/images/PBDQ_Style_3D_Cartoon.png') },
    { value: "2D_Vector_Flat", label: "Vector", image: require('../assets/images/PBDQ_Style_Vector.png') },
    { value: "Watercolor", label: "Watercolor", image: require('../assets/images/PBDQ_Style_Watercolor.png') },
    { value: "Isometric_3D", label: "Isometric", image: require('../assets/images/PBDQ_Style_Isometric.png') },
    { value: "Minimalist_Line_Art", label: "Minimalist", image: require('../assets/images/PBDQ_Style_Minimalist.png') },
    // { value: "Photorealistic", label: "Photorealistic", image: require('../assets/images/PBDQ_Style_Photorealistic.png') },
    { value: "Infographic_Style", label: "Infographic", image: require('../assets/images/PBDQ_Style_Infographic.png') },
    { value: "Pixel_Art", label: "Pixel", image: require('../assets/images/PBDQ_Style_Pixel.png') },
    { value: "Digital_Art", label: "Digital", image: require('../assets/images/PBDQ_Style_Digital.png') },
];

// --- Educational / Audience Tiers ---
export const TIERS = {
    T1: {
        label: "Lower Primary",
        age: "7-9"
    },
    T2: {
        label: "Upper Primary",
        age: "10-12"
    },
    T3: {
        label: "Middle School",
        age: "13-14"
    },
    T4: {
        label: "High School",
        age: "15-17"
    },
    T5: {
        label: "Tertiary",
        age: "18-22"
    },
    T6: {
        label: "General Public",
        age: "all ages"
    },
    T7: {
        label: "Workforce / Adult Professional",
        age: "25-64"
    }
};

export const AGE_TO_TIER_MAP = {
    "Below5":    "T1",
    "5-7YO":     "T1",
    "8-9YO":     "T1",
    "10-12YO":   "T2",
    "13-14YO":   "T3",
    "15-18YO":   "T4",
    "19-24YO":   "T5",
    "25-34YO":   "T5",
    "35-44YO":   "T5",
    "45-54YO":   "T5",
    "55-64YO":   "T5",
    "Above65":   "T5",
    "All":       "T6",
    "Workforce": "T7",
};

export const TIER_TO_AGE_MAP = {
    T1: '8-9YO',
    T2: '10-12YO',
    T3: '13-14YO',
    T4: '15-18YO',
    T5: '19-24YO',
    T6: 'All',
    T7: 'Workforce',
};

export function getTierLabel(code) {
    const t = TIERS[code];
    if (!t) return code || '';
    if (code === 'T6') return `${t.label} (${t.age})`;
    return `${t.label} (ages ${t.age})`;
}

/**
 * Resolves current tier selection from program details / wizard state:
 * Checks details.Tier first; if absent, maps details.Age to a tier.
 */
export function resolveTier(details) {
    if (!details) return '';
    if (details.Tier && TIERS[details.Tier]) {
        return details.Tier;
    }
    if (details.Age && AGE_TO_TIER_MAP[details.Age]) {
        return AGE_TO_TIER_MAP[details.Age];
    }
    return '';
}

// --- Activity Preferences & Tier Capabilities ---

export const ACTIVITY_OPTIONS = {
    qa: {
        value: 'qa',
        label: 'Knowledge Quiz',
        description: 'Scored quiz question with an answer reveal, explanation, and key takeaway.',
    },
    journaling: {
        value: 'journaling',
        label: 'Journaling',
        description: 'Reflective writing exercise connecting key concepts to personal experiences.',
    },
    group_discussion: {
        value: 'group_discussion',
        label: 'Group Discussion',
        description: 'Open-ended peer conversation exploring real-world dilemmas and trade-offs.',
    },
    tied_poll: {
        value: 'tied_poll',
        label: 'Decision Poll',
        description: 'Scenario poll where learners evaluate situations and choose the best course of action.',
    },
    design_challenge: {
        value: 'design_challenge',
        label: 'Hands-on Challenge',
        description: 'Practical creation task with a starter scenario, clear constraints, and success criteria.',
    },
};

export const TIER_ACTIVITIES = {
    T1: {
        recommended: ['qa', 'journaling'],
        available: ['qa', 'journaling'],
    },
    T2: {
        recommended: ['qa', 'group_discussion'],
        available: ['qa', 'group_discussion', 'journaling'],
    },
    T3: {
        recommended: ['group_discussion', 'tied_poll', 'journaling'],
        available: ['group_discussion', 'tied_poll', 'journaling'],
    },
    T4: {
        recommended: ['group_discussion', 'journaling', 'design_challenge'],
        available: ['group_discussion', 'tied_poll', 'journaling', 'design_challenge'],
    },
    T5: {
        recommended: ['group_discussion', 'journaling', 'journaling'],
        available: ['group_discussion', 'tied_poll', 'journaling', 'design_challenge'],
    },
    T6: {
        recommended: ['group_discussion', 'tied_poll', 'journaling'],
        available: ['group_discussion', 'tied_poll', 'journaling'],
    },
    T7: {
        recommended: ['tied_poll', 'design_challenge', 'journaling'],
        available: ['tied_poll', 'design_challenge', 'journaling', 'group_discussion'],
    },
};

export function getAvailableActivitiesForTier(tier) {
    const config = TIER_ACTIVITIES[tier] || TIER_ACTIVITIES.T4;
    return config.available.map(key => ACTIVITY_OPTIONS[key]).filter(Boolean);
}

export function getRecommendedActivitiesForTier(tier) {
    const config = TIER_ACTIVITIES[tier] || TIER_ACTIVITIES.T4;
    return config.recommended;
}

export function getRecommendedActivityLabels(tier) {
    const rec = getRecommendedActivitiesForTier(tier);
    const uniqueKeys = [...new Set(rec)];
    return uniqueKeys.map(key => ACTIVITY_OPTIONS[key]?.label || key).filter(Boolean);
}

// --- Digital Maturity (DQM) & Competencies Filtering Funnel ---

export const DQM_LEVELS = {
    DQM1: {
        code: 'DQM1',
        theme: 'Digital Citizenship',
        dqcRange: [1, 8],
        allowedTiers: ['T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    },
    DQM2: {
        code: 'DQM2',
        theme: 'Digital Creativity',
        dqcRange: [9, 16],
        allowedTiers: ['T1', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
    },
    DQM3: {
        code: 'DQM3',
        theme: 'Digital Competitiveness',
        dqcRange: [17, 24],
        allowedTiers: ['T5', 'T7'], // Adults Only (T5 Tertiary & T7 Workforce)
    },
};

/**
 * Extracts numeric ID from a DQC group string (e.g. 'DQC01' -> 1, 'DQC24' -> 24).
 */
export function getDqcNumber(dqcNo) {
    if (!dqcNo || typeof dqcNo !== 'string') return null;
    const match = dqcNo.trim().match(/^DQC(\d+)$/i);
    return match ? parseInt(match[1], 10) : null;
}

/**
 * Checks if a competency code belongs to core target groups DQC01 - DQC24
 * and is not soft-deleted.
 */
export function isCoreCompetency(item) {
    if (!item || item.is_deleted === true) return false;
    const dqcNum = getDqcNumber(item.dqc_no);
    if (!dqcNum || dqcNum < 1 || dqcNum > 24) return false;
    const code = item.dqco_no || item.code || '';
    if (typeof code === 'string' && code.length > 0) {
        if (!/^DQ_[A-Z0-9]+_\d+_\d+/i.test(code) && !/^DQ_/i.test(code)) {
            return false;
        }
    }
    return true;
}

/**
 * Checks if a competency is allowed for a given tier:
 * - T1-T4 and T6 are restricted to DQM1 & DQM2 (DQC01-DQC16).
 * - T5 and T7 (adults) are allowed DQM1, DQM2, and DQM3 (DQC01-DQC24).
 */
export function isCompetencyAllowedForTier(item, tier) {
    if (!isCoreCompetency(item)) return false;
    const dqcNum = getDqcNumber(item.dqc_no);
    if (dqcNum >= 17 && dqcNum <= 24) {
        return tier === 'T5' || tier === 'T7';
    }
    return true;
}

/**
 * Filters a raw list of competencies from listV3Level7DQCodeService by:
 * 1. Core target groups DQC01 - DQC24 and not deleted.
 * 2. Audience tier eligibility (strips DQM3 if tier is T1-T4 or T6).
 */
export function filterEligibleCompetencies(competenciesList, tier) {
    if (!Array.isArray(competenciesList)) return [];
    return competenciesList.filter(item => isCompetencyAllowedForTier(item, tier));
}

/**
 * Calculates competency capacity cap based on number of sessions:
 * competency_cap = min(3, sessions)
 * 1 session -> max 1
 * 2 sessions -> max 2
 * 3+ sessions -> max 3
 */
export function getCompetencyCap(numSessions) {
    const s = parseInt(numSessions, 10);
    if (isNaN(s) || s < 1) return 3;
    return Math.min(3, s);
}

/**
 * Extracts DQCO IDs (e.g. 'DQ_IND_09_02') from free text in order of first appearance.
 * Markdown-escaped underscores ('DQ\_IND\_09\_02') are unescaped first.
 */
export function extractDqcoIds(text) {
    if (typeof text !== 'string') return [];
    const matches = text.replace(/\\_/g, '_').match(/DQ_[A-Z]+_\d{2}_\d{2}/g) || [];
    return [...new Set(matches)];
}

/**
 * Normalises a competency list (codes, or { code } / { dqco_no } objects) into
 * unique, trimmed code strings in their original order.
 */
export function normalizeCompetencyCodes(list) {
    if (!Array.isArray(list)) return [];
    const codes = list
        .map(c => (typeof c === 'string' ? c : (c?.code || c?.dqco_no)))
        .map(code => (typeof code === 'string' ? code.trim() : ''))
        .filter(Boolean);
    return [...new Set(codes)];
}

/**
 * Collects the DQCO IDs quoted in DQ AI's (bot) chat messages, in order of first appearance.
 */
export function collectChatDqcoIds(chatHistory) {
    if (!Array.isArray(chatHistory)) return [];
    const ids = chatHistory
        .filter(m => m && m.type === CHAT_TYPE.BOT && typeof m.text === 'string')
        .flatMap(m => extractDqcoIds(m.text));
    return [...new Set(ids)];
}

/**
 * Checks if a competency is within the solution's DQC range ([min, max], any tier),
 * or - when the solution has no range - allowed for the audience tier.
 */
export function isCompetencyInSolutionScope(item, tier, dqcRange) {
    if (!Array.isArray(dqcRange)) return isCompetencyAllowedForTier(item, tier);
    if (!isCoreCompetency(item)) return false;
    const dqcNum = getDqcNumber(item.dqc_no);
    return dqcNum >= dqcRange[0] && dqcNum <= dqcRange[1];
}

/**
 * Resolves the competency options of the Edit program dialog from the first source that has any:
 * 1. 'suggested' - the list DQ AI suggested (wizard.SuggestedCompetencies). The server already
 *    scoped it, so nothing is filtered out, not even IDs missing from the catalog.
 * 2. 'chat'      - DQCO IDs quoted in DQ AI's chat messages,
 * 3. 'detected'  - the saved chat state's detectedCompetencies;
 *    for 2 and 3 only IDs in the catalog and within the solution scope count.
 * 4. 'scope'     - the whole catalog within the solution scope.
 * Steps 1-3 append the current selection (not already listed) so chosen values stay valid options.
 * Catalog entries are reused as options; an ID missing from the catalog gets a bare option.
 *
 * @returns {{ source: 'suggested'|'chat'|'detected'|'scope', options: object[] }}
 */
export function resolveCompetencyOptions({ suggested, chatHistory, detected, catalog, selected, tier, dqcRange }) {
    const items = Array.isArray(catalog) ? catalog : [];
    const selectedIds = normalizeCompetencyCodes(selected);
    const findItem = id => items.find(item => item?.dqco_no === id);
    const toOption = id => findItem(id) || { dqco_no: id, code: id, full_name: '', label: id };
    const withSelected = ids => [...ids, ...selectedIds.filter(id => !ids.includes(id))].map(toOption);
    const inScope = id => {
        const item = findItem(id);
        return Boolean(item) && isCompetencyInSolutionScope(item, tier, dqcRange);
    };

    const suggestedIds = normalizeCompetencyCodes(suggested);
    if (suggestedIds.length > 0) return { source: 'suggested', options: withSelected(suggestedIds) };

    const chatIds = collectChatDqcoIds(chatHistory).filter(inScope);
    if (chatIds.length > 0) return { source: 'chat', options: withSelected(chatIds) };

    const detectedIds = normalizeCompetencyCodes(detected).filter(inScope);
    if (detectedIds.length > 0) return { source: 'detected', options: withSelected(detectedIds) };

    return { source: 'scope', options: items.filter(item => isCompetencyInSolutionScope(item, tier, dqcRange)) };
}
